import React, {useEffect, useState} from "react";
import {
  Board,
  BoardHeader,
  BoardSearchResult,
  CancelButton,
  ColSpan0,
  ColSpan1, ColSpan3,
  ColSpan4,
  ColTitle,
  Input,
  InputLabel, mainColor, mainColorOpacity5,
  RelativeDiv,
  RowSpan,
  selectStyle, Site,
  Span1,
  Span4,
  SubmitButton,
  SubmitContainer,
  ValidationScript
} from "../../../assets/GlobalStyles";
import {AdverInfo} from "../styles/common";
import Select from "react-select";
import {useAtom, useSetAtom} from "jotai";
import {stepCampaignAtom} from "../entity";
import {Controller, useFormContext} from "react-hook-form";
import TimeTable from "../../../components/modal/TimeTable";
import {biddingTypeAll, campaignBasicInfoAtom} from "../entity/Info";
import {selBudgetTimeDetailInfo, selBudgetTimeList} from "../../../services/settings/BudgetTimeAxios";
import {timeBudgetDetailDataAtom} from "../../settings/entity/BudgetTime";
import {selBudgetInfo, updateCampaignBudget} from "../../../services/campaign/BudgetAxios";
import {campaignBudgetInfoAtom} from "../entity/Budget";
import {useLocation, useNavigate, useParams, useSearchParams} from "react-router-dom";
import {toast} from "react-toastify";
import {useResetAtom} from "jotai/utils";
import {confirmAlert} from "react-confirm-alert";
import 'react-confirm-alert/src/react-confirm-alert.css';
import {decimalFormat, multiAxiosCall, removeStr} from "../../../common/StringUtils";
import {campaignGroupInfoAtom} from "../entity/Group";
import queryString from "query-string";
import {SiteIcon} from "../../../components/layout";
import styled from "styled-components";
import {WarningModal} from "../../../components/modal/WarningModal";

export function CampaignTwo() {
  const setStepCampaign = useSetAtom(stepCampaignAtom)
  const [campaignBasicInfo, setCampaignBasicInfo] = useAtom(campaignBasicInfoAtom)
  const [campaignBudgetInfo, setCampaignBudgetInfo] = useAtom(campaignBudgetInfoAtom)
  const [budgetRateChk, setBudgetRateChk] = useState(false)
  const [budgetTimeListState, setBudgetTimeListState] = useState(null)
  const [biddingType] = useState(biddingTypeAll)
  const [timeBudgetDetailDataState, setTimeBudgetDetailDataState] = useAtom(timeBudgetDetailDataAtom)
  const location = useLocation()
  const navigate = useNavigate()
  const {register, handleSubmit,reset,setError, control, formState: {errors}, clearErrors} = useFormContext()
  const resetGroupInfo = useResetAtom(campaignGroupInfoAtom)
  const state = location.search !== '' ? queryString.parse(location.search) : location.state
  useEffect(() => {
    let userId = state !== null ? state.userId : campaignBasicInfo?.userId;

    const callbackFunc = (response) => {
      const budgetTimeList = response[0]?.timeGroups.map(data => {return {value: data.id, label: data.groupName}});

      setBudgetTimeListState(budgetTimeList);

      if(budgetTimeList.size > 0){
        selBudgetTimeDetailInfo(userId, budgetTimeList[0].value).then(response => {
          setTimeBudgetDetailDataState(response)
        })
      }

      if(state == null && ['INIT'].includes(campaignBasicInfo.step)){
        setCampaignBudgetInfo({
          ...campaignBudgetInfo,
          budgetTimeId: budgetTimeList[0]?.value,
        })
      }
    }
    multiAxiosCall([selBudgetTimeList(userId)], callbackFunc);
    // eslint-disable-next-line react-hooks/exhaustive-deps

    if (state !== null || ['STEP2_BUDGET','STEP3_INVENTORY','STEP4_CREATIVE','COMPLETED'].includes(campaignBasicInfo.step)) {
      //수정
      let campaignId = (state !== null ? state.campaignId : campaignBasicInfo.campaignId);

      selBudgetInfo(campaignId).then(response => {
        const data = response;
        let budgetRate = {budgetRate : Math.round(response.dailyAvgBudget !== 0 ? (response.pcBudget * 100 / response.dailyAvgBudget): 50)}
        Object.assign(data,budgetRate);
        // 수정에서 기존 예산비율 한쪽이 0에서 올라갈 경우 true, 수정 버튼 클릭시 알럿창 호출
        (response.pcBudget === 0 || response.mobBudget === 0) && setBudgetRateChk(true)
        setCampaignBudgetInfo(data);
        selBudgetTimeDetailInfo(userId, data.budgetTimeId).then(response => {
          setTimeBudgetDetailDataState(response);
        })
        reset(response);
      })
    }
  }, [location.state])
  /**
   * 시간대별 예산 셀렉트
   * @param selectedBudgetTime
   */
  const handleChangeBudgetTimes = (selectedBudgetTime) => {
    setCampaignBudgetInfo({
      ...campaignBudgetInfo,
      budgetTimeId: selectedBudgetTime.value,
    })
    let userId = state !== null ? state.userId : campaignBasicInfo.userId;
    selBudgetTimeDetailInfo(userId, selectedBudgetTime.value).then(response => {
      setTimeBudgetDetailDataState(response)
    })

    clearErrors('budgetTimeId')
  }
  /**
   * 이벤트 단가 셀렉트
   * @param selectedPriceEvent
   */
  const handleChangePriceEvent = (selectedPriceEvent) => {
    let num = removeStr(selectedPriceEvent)
    let price = num !== '' ? parseInt(num) : 0
    setCampaignBudgetInfo({
      ...campaignBudgetInfo,
      biddingPrice: parseInt(price),
    })
    clearErrors('biddingPrice')
  }
  /**
   * 이벤트 예산 셀렉트
   * @param selectedBudgetEvents
   */
  const handleChangeBudgetEvents = (selectedBudgetEvents) => {
    setCampaignBudgetInfo({
      ...campaignBudgetInfo,
      targetingBudgetId: selectedBudgetEvents.value,
    })
    clearErrors('targetingBudgetId')
  }

  const handleBiddingType = (selectedBiddingType) => {
    setCampaignBudgetInfo({
      ...campaignBudgetInfo,
      biddingType: selectedBiddingType.value,
    })
  }

  const handleCheckInfiniteBudget = (e) => {
    let value = e.target.checked ? 'Y' : 'N'
    clearErrors('dailyAvgBudget')
    setCampaignBudgetInfo({
      ...campaignBudgetInfo,
      infiniteBudgetYn: value,
    })
  }

  const handleChangeDailyBudget = (value) => {
    let num = removeStr(value)
    let dailyBudget = num !== '' ? parseInt(num) : 0

    const prevBudgetRate = campaignBudgetInfo.budgetRate !== 0 ? campaignBudgetInfo.budgetRate : 50;
    clearErrors('dailyAvgBudget')
    setCampaignBudgetInfo({
      ...campaignBudgetInfo,
      dailyAvgBudget: dailyBudget,
      pcBudget: dailyBudget * prevBudgetRate / 100,
      mobBudget: dailyBudget * (100-prevBudgetRate) / 100,
      budgetRate: prevBudgetRate
    })

  }

  const handleChangePcBudget = (value) => {
    let num = removeStr(value)
    let puBudget = value !== '' ? parseInt(num) : 0

    if (campaignBudgetInfo.dailyAvgBudget < 100 || campaignBudgetInfo.dailyAvgBudget.toString().slice(-2) !== '00') {
      setError('dailyAvgBudget', {type: 'required', message: '일일 평균 예산을 최소 100원 단위로 설정해주세요.'})
    } else if(puBudget <= campaignBudgetInfo.dailyAvgBudget) {
      setCampaignBudgetInfo({
        ...campaignBudgetInfo,
        pcBudget: puBudget,
        mobBudget: campaignBudgetInfo.dailyAvgBudget - puBudget,
        budgetRate: campaignBudgetInfo.dailyAvgBudget !== 0 ? Math.round(puBudget * 100 / campaignBudgetInfo.dailyAvgBudget) : 50
      })
    }
  }

  const handleChangeMobileBudget = (value) => {
    let num = removeStr(value)
    let mobBudget = value !== '' ? parseInt(num) : 0

    if (campaignBudgetInfo.dailyAvgBudget < 100 || campaignBudgetInfo.dailyAvgBudget.toString().slice(-2) !== '00') {
      setError('dailyAvgBudget', {type: 'required', message: '일일 평균 예산을 최소 100원 단위로 설정해주세요.'})
    } else if(mobBudget <= campaignBudgetInfo.dailyAvgBudget ){
      setCampaignBudgetInfo({
        ...campaignBudgetInfo,
        mobBudget: mobBudget,
        pcBudget: campaignBudgetInfo.dailyAvgBudget - mobBudget,
        budgetRate: campaignBudgetInfo.dailyAvgBudget !== 0 ? Math.round(mobBudget * 100 / campaignBudgetInfo.dailyAvgBudget) : 50
      })
    }
  }
  const handleChangeInputRange = (e) => {
    if(campaignBudgetInfo.infiniteBudgetYn !== 'Y') {
      if (campaignBudgetInfo.dailyAvgBudget < 100 || campaignBudgetInfo.dailyAvgBudget.toString().slice(-2) !== '00') {
        setError('dailyAvgBudget', {type: 'required', message: '일일 평균 예산을 최소 100원 단위로 설정해주세요.'})
      } else {
        setCampaignBudgetInfo({
          ...campaignBudgetInfo,
          budgetRate: parseInt(e.target.value),
          mobBudget: campaignBudgetInfo.dailyAvgBudget - ((campaignBudgetInfo.dailyAvgBudget * e.target.value) / 100),
          pcBudget: (campaignBudgetInfo.dailyAvgBudget * e.target.value) / 100
        })
      }
    }
  }

  const handleChangeMaxBid = (value) => {
    let num = removeStr(value)
    let maxBiddingPrice = value !== '' ? parseInt(num) : 0
    clearErrors('maxBiddingPrice')
    setCampaignBudgetInfo({
      ...campaignBudgetInfo,
      maxBiddingPrice: maxBiddingPrice
    })
  }
  const handleBudgetTime = () => {
    navigate("/board/budgetTimeList", {state: {id:state !== null ? state.userId : campaignBasicInfo.userId}})
  }

  const onError = (e) => {console.log(e)}
  const onSubmit = () => {
    if (campaignBudgetInfo.maxBiddingPrice !== 0) {
      setError('maxBiddingPrice', {type: 'required', message: '최대 입찰가를 입력해주세요'})
    } else if(campaignBudgetInfo.infiniteBudgetYn !== 'Y' && (campaignBudgetInfo.dailyAvgBudget < 100 || campaignBudgetInfo.dailyAvgBudget.toString().slice(-2) !== '00')) {
      setError('dailyAvgBudget', {type: 'required', message: '일일 평균 예산을 최소 100원 단위로 설정해주세요.'})
    } else {
      let campaignId = state !== null ? state.campaignId : campaignBasicInfo.campaignId
      updateCampaignBudget({
        ...campaignBudgetInfo,
        campaignId: campaignId,
        targetingPriceId: 1
      }).then(response => {
        if (response) {
          if (state !== null) {
            if(campaignBudgetInfo.infiniteBudgetYn !== 'Y' && (campaignBudgetInfo.pcBudget === 0 || campaignBudgetInfo.mobBudget === 0 || budgetRateChk)) {
              confirmAlert({
                title: '수정되었습니다',
                message: '예산 비율 설정에 따라 광고 그룹 및 크리에이티브 정보를 확인해주세요.',
                buttons: [
                  {
                    label: '확인',
                    onClick: () => {
                      navigate('/board/dashboard')
                    }
                  }
                ]
              });
            } else {
              toast.success("수정되었습니다.",{autoClose:100, delay:0})
              toast.onChange(payload => {
                if (payload.status === "removed" && payload.type !== toast.TYPE.ERROR) {
                  navigate('/board/dashboard')
                }
              })
            }
          } else {
            if(!['STEP2_BUDGET','STEP3_INVENTORY','STEP4_CREATIVE','COMPLETED'].includes(campaignBasicInfo.step)){
              setCampaignBasicInfo({
                ...campaignBasicInfo,
                step: "STEP2_BUDGET"
              })
            }
            setStepCampaign({steps: 2})
          }
        }
      })
      resetGroupInfo()
    }
  }
  return (
    <form onSubmit={handleSubmit(onSubmit, onError)}>
      {state !== null && <AdverInfo><span>광고주 정보</span><p></p><span>{state?.adverInfo}</span></AdverInfo>}
      <Board>
        <BoardHeader>예산 및 입찰 설정</BoardHeader>
        <BoardSearchResult>
          <RowSpan>
            <Span4>예산설정</Span4>
          </RowSpan>
          <RowSpan box={true} column={true}>
            <ColSpan4>
              <Span4>일일 평균 예산</Span4>
              <RelativeDiv>
                <ColSpan1>
                  <InputLabel label={'원'}>
                    <Input type={'text'}
                           step={100}
                           maxLength={13}
                           readOnly={campaignBudgetInfo.infiniteBudgetYn !== 'N' && true}
                           placeholder={campaignBudgetInfo.infiniteBudgetYn !== 'Y' ? '일일 평균 예산을 설정해주세요.' : ''}
                           {...register("dailyAvgBudget", {
                             required: campaignBudgetInfo.infiniteBudgetYn !== 'Y' && "일일 평균 예산을 설정해주세요.",
                             pattern:{
                               value: /^[0-9,]+$/,
                               message: "숫자만 입력 가능합니다."
                             },
                             onChange:(e) => handleChangeDailyBudget(e.target.value)
                           })}
                           value={campaignBudgetInfo.infiniteBudgetYn !== 'Y' ? decimalFormat(campaignBudgetInfo.dailyAvgBudget) : ''}
                    />
                  </InputLabel>
                </ColSpan1>
                <ColSpan0>
                  <label>
                    <input type={'checkbox'} value={campaignBudgetInfo.infiniteBudgetYn} checked={campaignBudgetInfo.infiniteBudgetYn !== 'N' && true} className={'checkbox-type-a'} onChange={handleCheckInfiniteBudget}/>
                    <i/>
                    {/*배너일때 infiniteBudget 항목 없음*/}
                    <span>일일 예산 무제한</span>
                  </label>
                </ColSpan0>
                <ColSpan1> {errors.dailyAvgBudget &&
                  <ValidationScript style={{position: 'unset'}}>{errors.dailyAvgBudget.message}</ValidationScript>}</ColSpan1>
              </RelativeDiv>
            </ColSpan4>
            <ColSpan4>
              <Span4>예산 비율</Span4>
              <RelativeDiv>
                <ColSpan1>
                  <Span1>PC</Span1>
                  <InputLabel label={'원'}>
                    <Input type={'text'}
                           readOnly={campaignBudgetInfo.infiniteBudgetYn !== 'N' && true}
                           step={10}
                           {...register("pcBudget", {
                             pattern:{
                               value: /^[0-9,]+$/,
                               message: "숫자만 입력 가능합니다."
                             },
                             onChange:(e) => handleChangePcBudget(e.target.value)
                           })}
                           value={campaignBudgetInfo.infiniteBudgetYn !== 'Y' ? decimalFormat(campaignBudgetInfo.pcBudget) : ''}
                    />
                  </InputLabel>
                </ColSpan1>
                <ColSpan1>
                  <input
                    className={campaignBudgetInfo.infiniteBudgetYn !== 'N' ? 'read-only' : ''}
                    type="range"
                    value={campaignBudgetInfo.budgetRate !== undefined ? campaignBudgetInfo.budgetRate : 0}
                    onChange={handleChangeInputRange}
                    style={{
                      background: `linear-gradient(to right, #ff0000 0%, #f08 ${campaignBudgetInfo.budgetRate !== undefined ? campaignBudgetInfo.budgetRate: 50}%, #80f ${campaignBudgetInfo.budgetRate !== undefined ? campaignBudgetInfo.budgetRate: 50}%, #00f 100%)`
                    }}
                  />
                  {/*<Span1>*/}
                  {/*  {campaignBudgetInfo.budgetRate +':'+ (100-campaignBudgetInfo.budgetRate)}*/}
                  {/*</Span1>*/}
                </ColSpan1>
                <ColSpan1>
                  <ColTitle><Span1>MOBILE</Span1></ColTitle>
                  <InputLabel label={'원'}>
                    <Input type={'text'}
                           readOnly={campaignBudgetInfo.infiniteBudgetYn !== 'N' && true}
                           step={10}
                           {...register("mobBudget", {
                             pattern:{
                               value: /^[0-9,]+$/,
                               message: "숫자만 입력 가능합니다."
                             },
                             onChange:(e) => handleChangeMobileBudget(e.target.value)
                           })}
                           value={campaignBudgetInfo.infiniteBudgetYn !== 'Y' ? decimalFormat(campaignBudgetInfo.mobBudget) : ''}
                    />
                  </InputLabel>
                </ColSpan1>
              </RelativeDiv>
            </ColSpan4>
            <ColSpan4>
              <Span4>시간별 예산 그룹</Span4>
              <RelativeDiv>
                <ColSpan1>
                  {budgetTimeListState !== null &&
                    <Controller
                      name="budgetTimeId"
                      control={control}
                      rules={{
                        required: {
                          value: campaignBudgetInfo?.budgetTimeId === undefined,
                          message: "시간대 예산을 선택해주세요"
                        }
                      }}
                      render={({field}) => (
                        <Select options={budgetTimeListState}
                                placeholder={'시간대 예산 선택'}
                                {...field}
                                value={campaignBudgetInfo?.budgetTimeId !== '' ? budgetTimeListState.find(value => value.value === campaignBudgetInfo?.budgetTimeId) : budgetTimeListState[0]}
                                onChange={handleChangeBudgetTimes}
                                styles={selectStyle}
                        />
                      )}
                    />
                  }
                </ColSpan1>
                {timeBudgetDetailDataState !== null &&
                  <>
                    <ColSpan0>
                    <TimeTable
                        exposureTimeType={timeBudgetDetailDataState?.exposureTimeType !== undefined ? timeBudgetDetailDataState.exposureTimeType : timeBudgetDetailDataState?.timeGroups.find(value => value.id === campaignBudgetInfo?.budgetTimeId)}
                      title={'설정된 시간별 예산'} readOnly={true}/>
                    </ColSpan0>
                    <ColSpan1>
                      <ButtonDiv>
                        <WarningModal title={"예산 그룹 추가 및 수정"} onSubmit={handleBudgetTime} btnStyle={'warning'}/>
                        {/*<div onClick={() => navigate("/board/budgetTimeList", {state: {id:state !== null ? state.userId : campaignBasicInfo.userId}})}>*/}
                        {/*  예산 그룹 추가 및 수정<Site/>*/}
                        {/*</div>*/}
                      </ButtonDiv>
                    </ColSpan1>
                  </>
                }
                {errors.budgetTimeId &&
                  <ColSpan1><ValidationScript>{errors.budgetTimeId.message}</ValidationScript></ColSpan1>}
              </RelativeDiv>
            </ColSpan4>
          </RowSpan>
          <RowSpan>
            <Span4>과금 설정</Span4>
          </RowSpan>
          <RowSpan box={true} column={true}>
            <ColSpan4>
              <Span4>입찰 방식</Span4>
              <RelativeDiv>
                <ColSpan1>
                  <Select styles={selectStyle}
                          components={{IndicatorSeparator: () => null}}
                          options={biddingType}
                          value={biddingType.find(value => value.value === campaignBudgetInfo?.biddingType)}
                          onChange={handleBiddingType}
                  />
                </ColSpan1>
              </RelativeDiv>
            </ColSpan4>
            {/*
            <ColSpan4>
              <Span4>최대 입찰가</Span4>
              <RelativeDiv>
                <ColSpan1>
                  <InputLabel label={'원'}>
                    {campaignBudgetInfo !== null &&
                      <Controller
                        name="maxBiddingPrice"
                        control={control}
                        rules={{
                          required: {
                            value:campaignBudgetInfo !== null && campaignBudgetInfo.maxBiddingPrice === 0,
                            message: '최대 입찰가를 설정해주세요'
                          }
                        }}
                        render={({ field }) =>(
                          <Input type={'text'}
                                 step={100}
                                 maxLength={13}
                                  {...field}
                                 placeholder={'최대 입찰가를 설정해주세요'}
                                 style={{color:'#f5811f'}}
                                 value={campaignBudgetInfo !== null && decimalFormat(campaignBudgetInfo.maxBiddingPrice)}
                                 onChange={(e)=>handleChangeMaxBid(e.target.value)}
                          /> )}
                      />
                    }
                  </InputLabel>
                </ColSpan1>
                {errors.maxBiddingPrice &&
                  <ColSpan1><ValidationScript>{errors.maxBiddingPrice.message}</ValidationScript></ColSpan1>}
              </RelativeDiv>
            </ColSpan4>
             */}
            <ColSpan4>
              <Span4>단가 설정</Span4>
              <RelativeDiv>
                <ColSpan1>
                  <InputLabel label={'원'}>
                    <Input type={'text'}
                           step={100}
                           maxLength={13}
                           placeholder={campaignBudgetInfo.biddingPrice !== 0 ? '단가를 입력해주세요.' : ''}
                           {...register("biddingPrice", {
                             required: campaignBudgetInfo.biddingPrice !== 0 && "단가를 입력해주세요.",
                             pattern:{
                               value: /^[0-9,]+$/,
                               message: "숫자만 입력 가능합니다."
                             },
                             onChange:(e) => handleChangePriceEvent(e.target.value)
                           })}
                           value={campaignBudgetInfo.biddingPrice !== 0 ? decimalFormat(campaignBudgetInfo.biddingPrice) : 0}
                    />
                  </InputLabel>
                </ColSpan1>
                {errors.biddingPrice &&
                  <ColSpan1><ValidationScript>{errors.biddingPrice.message}</ValidationScript></ColSpan1>}
              </RelativeDiv>
            </ColSpan4>
          </RowSpan>
        </BoardSearchResult>
      </Board>
      <SubmitContainer>
        <CancelButton type={'button'} onClick={() => state !== null ? navigate(-1) : setStepCampaign({steps: 0})}>{state !== null ? '목록' : '이전'}</CancelButton>
        <SubmitButton type={'submit'}>{state !== null ? '수정' : '다음[2/4]'}</SubmitButton>
      </SubmitContainer>

    </form>
  )
}

const ButtonDiv = styled.div`
& > div {
  border-radius: 5px;
  background-color: ${mainColorOpacity5};
  border: 1px solid #e5e5e5;
  color: #000;
  padding-left: 10px;
  font-size: 14px;
  cursor: pointer;
  -webkit-box-align: center;
  align-items: center;
  justify-content: center;
  display:flex;
}`